// removed by extract-text-webpack-plugin
module.exports = {"heading5":"_2csIId9tt1j85cuXCTKXzs","card-header":"_3TKZu1CfJCJ3fcj2RJe3fw","card-section":"_2IREXElPkEFQDiwDzDZyIQ","heading6":"_2ojQ0VjJlNunaDu6Iyb965","terms":"_1ORi0wMfeGX1dLVnR1R4S9","settlement-details":"_2MPguxKWROsMSm8n6lbyqS","headerLogo":"cn_VFidHYVwzLOeHfBLK9"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/CertificateSettlement/style.scss
// module id = 2563
// module chunks = 1